import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    text: 'Meine 2 Rhodesian Ridgeback haben sehr viel Gras gefressen. Seit ca. 3 Wochen bekommen die Jungs morgens ihren Löffel ins Futter und es ist deutlich Besserung in Sicht.',
    author: 'Klaus & die Ridgeback-Jungs'
  }, {
    text: 'Das Futtertopping Magen & Darm ist echt richtig gut. Unser Golden Retriever ist viel besser drauf was die Verdauung betrifft. Ein absolut empfehlenswertes Produkt.',
    author: 'Familie Berger & Ben'
  }, {
    text: 'Nach zwei Wochen hatte unser Hund keine Beschwerden mehr. So einfach.',
    author: 'Thomas aus Hamburg'
  }, {
    text: 'Seit wir das Magen-Darm-Topping regelmäßig geben, geht es unserem Labrador viel viel besser. Macht weiter so!',
    author: 'Familie Weber & Charlie'
  }];
  return <section className="w-full px-4 py-16 bg-cream-dark/50" data-id="element-118">
      <div className="max-w-6xl mx-auto" data-id="element-119">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="font-handwriting text-4xl md:text-5xl text-center text-forest font-bold mb-12" data-id="element-120">
          Was andere Hundebesitzer sagen
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-121">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-brown/10" data-id="element-122">
              <div className="flex gap-1 mb-4" data-id="element-123">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-124" />)}
              </div>
              <p className="font-serif text-gray-700 italic mb-6 leading-relaxed" data-id="element-125">
                "{review.text}"
              </p>
              <p className="font-serif font-semibold text-forest" data-id="element-126">
                – {review.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}